import React, { useState, useEffect } from 'react'
import { Container, Left, Right } from 'components/UIComponents/Toggle/style'
import { COLORS } from 'theme'

const Toggle = (
  {
    left,
    right,
    width = 'fit-content',
    fontSize = '14px',
    justify = 'center',
    onClick, // <- make sure this is passed
    initialValue = 'left',
    checked,
    disabled = false,
    stringMode = false, // optional: support stringMode
  },
  props
) => {
  const [current, setCurrent] = useState(initialValue)

  useEffect(() => {
    if (checked !== undefined) {
      // If checked prop is provided, use it to determine current state
      const isLeft = checked === left
      setCurrent(isLeft ? 'left' : 'right')
    } else {
      setCurrent(initialValue)
    }
  }, [initialValue, checked, left])

  const handleClick = curr => {
    setCurrent(curr)
    if (onClick) {
      onClick(stringMode ? (curr === 'left' ? `${left}` : `${right}`) : curr === 'right')
    }
  }

  return (
    <Container
      disabled={disabled}
      width={width}
      fontSize={fontSize}
      justify={justify}
    >
      <Left
        color={current === 'left' ? COLORS.PRIMARY : COLORS.GREY_T_80}
        background={current === 'left' ? COLORS.BLUE_T_90 : COLORS.WHITE}
        onClick={() => !disabled && handleClick('left')}
        disabled={disabled}
      >
        {left}
      </Left>
      <Right
        color={current === 'right' ? COLORS.PRIMARY : COLORS.GREY_T_80}
        background={current === 'right' ? COLORS.BLUE_T_90 : COLORS.WHITE}
        onClick={() => !disabled && handleClick('right')}
        disabled={disabled}
      >
        {right}
      </Right>
    </Container>
  )
}

export default Toggle
